import { NgModule } from '@angular/core';
import { reportingRouting } from './reporting.routing'
import { UiHelperModule } from "../../ui-helper";

import { ReportingListComponent } from './reporting-list/reporting-list.component';
import { ReportingListPresentation } from './reporting-list/reporting-list.presentation';
import { BookingOfficeReportingListComponent } from "./bo-reporting-list/bo-reporting-list.component";
import { BookingOfficeReportingListPresentation } from "./bo-reporting-list/bo-reporting-list.presentation";

@NgModule({
	imports: [
		reportingRouting,
		UiHelperModule,
	],
	declarations: [
		ReportingListComponent,
		ReportingListPresentation,
		BookingOfficeReportingListComponent,
		BookingOfficeReportingListPresentation,
	],
})

export class ReportingModule {
	static forRoot() {
		return {
			ngModule: ReportingModule
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/reporting/reporting.module.ts